package com.svdsak.util

import org.jetbrains.compose.web.css.Color
import kotlin.js.Date

object Res {

    val WEBSITE_BG_COLOR = Color("#1A3636")
    val SECONDARY_COLOR = Color("#40534C")
    val TERTIARY_COLOR = Color("#677D6A")
    val QUATRIATIC_COLO = Color("#D6BD98")

    val COPY_RIGHT = "© Copyright ${Date().getFullYear()} | SVDSAK - KOWTHALAM(A.P)"
    const val DEVELOPED_BY = "Developed By "
    const val DEV_COMPANY_NAME = "VRaJaT Creations"
    const val HEADER = "Hare Shrinivaasa :: Guro Raghavendra"
}